import React from 'react';

import {FooterModuleBottom} from "../footer-module.bottom";
import {FooterModuleMobileSocialStoreButtons} from "./footer-module.mobile.social-store-buttons";
import {FooterModuleDisclaimer} from "../footer-module.disclaimer";
import {FooterModuleMobileLinks} from "./footer-module.mobile.links";
import {FooterModuleBettingDisclosure} from "../footer-module.betting-disclosure";
import classNames from "classnames";
import {observer} from 'mobx-react';
import styles from "../../styles/footer.module.scss";
import {FooterModuleLangPicker} from "../footer-module.lang-picker";

export const FooterModuleMobile = observer(({controller, onItemClick}) => {
  const {state} = controller;
  const {description, shouldRenderLangMenu} = state;

  const linksProps = {
    controller,
    onItemClick
  }

  return (
    <div className={classNames(styles.content)}>
      <FooterModuleMobileSocialStoreButtons controller={controller}/>
      <FooterModuleMobileLinks {...linksProps}/>
      <FooterModuleDisclaimer controller={controller}/>
      <FooterModuleLangPicker shouldRenderLangMenu={shouldRenderLangMenu}/>
      <div className={classNames(styles.top_content_description)}>{description}</div>
      <FooterModuleBettingDisclosure controller={controller}/>
      <FooterModuleBottom controller={controller}/>
    </div>
  );
})
